import { useCallback } from "react";

import { FormLens } from "@tdp/common/form";

interface FormInputProps {
  value: string;
  //TODO(nibeauli): figure out if we need a generic react event for the first parameter
  onChange: (_: unknown, data: { value: string }) => void;
}

/**
 * Get the props for a fluentui 'Input' component for a specified form lens.
 * 
 * Note: this will convert the input component into a controlled component by setting both the value and the change handler.
 * @param lens the form lens.
 * @param options additional options for customizing the validation errors.
 * @returns props for the <Input /> component. 
 */
export function useFormInputProps(lens: FormLens<string>): FormInputProps {
  const onInputChange = useCallback(
    (_: unknown, data: { value: string }) => {
      lens.update(() => data.value);
    },
    [lens.update]
  );

  return {
    onChange: onInputChange,
    value: lens.current,
  }
}
